import { createStore, applyMiddleware } from 'redux';
import rootReducer from '../reducers/rootReducer';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { getFirebase } from 'react-redux-firebase';
import { reduxFirestore, getFirestore, createFirestoreInstance } from 'redux-firestore';
import firebase from '../firebase/firebase';

const rrfConfig = {
	userProfile: 'users',
	attachAuthIsReady: true,
	userFirestoreForProfile: true,
	updateProfileOnLogin: false,
	createFirestoreInstance
};

export const configureStore = (preloadedState) => {
	const middlewares = [ thunk.withExtraArgument({ getFirebase, getFirestore }) ];
	const middlewareEnhancer = applyMiddleware(...middlewares);

	const storeEnchancers = [ middlewareEnhancer ];

	const composedEnchancer = composeWithDevTools(...storeEnchancers, reduxFirestore(firebase, rrfConfig));

	const store = createStore(rootReducer, preloadedState, composedEnchancer);
	return store;
};
